export const TOOLTIP_BG_COLOR = 'gray.800'

export const TooltipsTheme = {
  defaultProps: {
    bg: TOOLTIP_BG_COLOR,
  },
}
